import { HTTP, authHeader } from './http-service';

class BusinessRegistrationSearchService {
  search(payload) {
    return HTTP.post(`/BusinessRegistrationSearch`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  advancedSearch(payload) {
    return HTTP.post(`/BusinessRegistrationSearch/advance`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }
}

export default new BusinessRegistrationSearchService();
